import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../../ui_kit/select/Select';

function SelectWrapper(props) {
  const {
    input: {
      value, onChange, onFocus, onBlur, name,
    }, label, options, className, defaultOption, meta: { touched, error },
  } = props;

  if (!options[0]) { return null; }

  if (value === '') {
    onChange(options[0].id);
  }

  return (
    <Select
      label={label}
      options={options}
      value={value || 'default'}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      name={name}
      error={touched ? error : null}
      className={className}
      defaultOption={defaultOption}
    />
  );
}

SelectWrapper.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  className: PropTypes.string,
  defaultOption: PropTypes.node,
};

export default SelectWrapper;
